<template>
    <section>
        <div class="logoheader m0">
            <h1><img src="/static/images/login/server_header.png" alt="logo"></h1>
        </div>
        <div class="mainwrap">
            <!--login-->
            <div class="mainbox m0 pr">
                <p class="server_text pa"><img src="/static/images/login/server_text.png"></p>
                <div class="fr logouterbox">
                <div class="logouter" >
                        <ul class="tabchange">
                            <li class="user" :class="{ active:loginType==0 }" @click="changeType(0)">学员登录</li>
                            <li class="plat" :class="{ active:loginType==1 }" @click="changeType(1)">培训机构登录</li>
                        </ul>
                        <div class="tableCheck mt10"></div>
                        <div class="layer">
                            <p id="warning" class="prompt show"><i class="iconfont"></i>公共场所不建议自动登录，以防账号丢失</p>
                        </div>
                        <!-- 用户名和密码选择框 -->
                        <el-form label-position="left" label-width="0px" class="demo-ruleForm login-container" :model="ruleForm" :rules="rules" ref="formName" >
                            <div @keyup.enter="doLogin('formName')">
                                <el-form-item prop="mobile">
                                    <el-input class="mt10" type="text" ref="input_mobile" @keyup.enter.native="doLogin('formName')" v-model="ruleForm.mobile" placeholder="请输入用户名" autofocus="autofocus"></el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input type="password" v-model="ruleForm.password" class="loginInput mt20" placeholder="请输入密码" @keyup.enter.native="doLogin('formName')"></el-input>
                                </el-form-item>
                                <el-form-item style="width:100%;">
                                    <el-button type="primary" style="width:100%;font-size:26px;font-weight:bold;" class="mt10" @click="doLogin('formName')" >登 录</el-button>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <!--footer-->
        <div class="loginfooter tc">
            <p ><span>主办单位：中国国家人事人才培训网</span><span style="margin-left: 36px;">服务热线：400-0666-099</span> </p>
        </div>
    </section>

</template>

<script>
    import '../../static/css/log.css'
    import md5 from 'js-md5'
    export default {
        data() {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('*用户名不能为空'));
                } else  {
                    const reg = /^[-a-zA-Z0-9_]{2,30}$/
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('*用户名需输入字母、数字'));
                    }
                }
            };
            return {
                phone:'',
                loginType:'0',//登录类型
                ruleForm: {
                    mobile: '',
                    password: '',
                },
                rules: {
                    mobile: [
                        {validator: checkPhone, trigger: 'blur'}
                    ],
                    password: [
                        { required: true, message: '*请输入密码', trigger: 'blur' },
                        { min: 3, message: '*密码长度太短', trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            changeType(type){
                this.loginType=type;
                this.ruleForm.mobile='';
                this.ruleForm.password='';

            },

            doLogin(formName) {

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$router.push({ path: '/personal/myexam' });
                        this.$axiosPackag.post('/user/logindo', { 'userName':this.ruleForm.mobile, 'password1': md5(this.ruleForm.password)}, r => {
                            this.$sessionStore.initSession(r);
                            //重定向地址
                            let  redirect = this.$route.query.redirect;

                            //如果有重定向地址的话,就走重定向地址 所有的重定向地址必须约定好为 'redirect' 字段,不允许出现污染,否则无法进行定位.
                            if(redirect){

                                this.$router.push({ path:redirect });
                            }else{
                                //学员
                                if(r.ifStudent){

                                    // window.parent.location.href ='/#/personal/personalSet'
                                } else{
                                    // this.$router.push({ path: '/platAdmin/pending' });
                                    window.parent.location.href ='/#/platAdmin/pending'
                                }
                            }
                        });
                    }else{
                        //表单校验未通过
                        return false;
                    }
                });
            },

        }
    }

</script>
<style lang="scss" scoped>
    body{min-width: 1200px;}
    .logoheader{height: 285px;width: 100%;background: url("/static/images/login/gp_servertop.jpg") no-repeat top right;}
    .logoheader h1{width: 1200px;margin: 0 auto;}
    .logoheader h1 img{margin-top: 80px;}
    .mainwrap{width: 100%;height: 498px;background: url("/static/images/login/gp_serverbg.jpg") no-repeat center top;}
    .loginfooter{height: 296px;width: 100%;background: url("/static/images/login/gp_serverbtm.jpg") no-repeat center top}
    .mainbox{width: 1200px;height: 498px;}
    .server_text{top: 105px;left: 8px;}
    .loginfooter p{padding-top: 80px;}
    .loginfooter p span{font-size: 16px;color: #000;}
    .mainbox iframe{position: absolute;right: 34px;top: 62px;}
    .tabchange{padding-top: 23px;height: auto;overflow: hidden}
    .tabchange li{float: left;color: #666464;font-size: 24px;font-family: '微软雅黑';border-bottom: 3px solid #666464;padding-bottom: 4px;cursor: pointer;}
    .tabchange li.user{padding-left: 35px;background: url("/static/images/login/server_user03.png") no-repeat 5px top;}
    .tabchange li.user.active{color:#063e77;background: url("/static/images/login/server_user01.png") no-repeat 5px top;border-bottom: 3px solid #000}
    .tabchange li.plat{padding-left: 35px;background: url("/static/images/login/server_plat01.png") no-repeat 5px top;width: 147px;}
    .tabchange li.plat.active{color:#063e77;background: url("/static/images/login/server_plat02.png") no-repeat 5px top;border-bottom: 3px solid #000}
    .logouter {width: 420px;box-sizing: border-box;box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.3);padding: 10px 50px 30px;margin-top:70px;float: right;background: #fff}
    /*.logouterbox{background-color: #FFFFFF;width: 420px;height: 446px;box-sizing: border-box;*/
    /*   box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.3);}*/
    .prompt {color: #656565;border: 1px solid #ffca00;background-color: #fff4ca;margin: 20px 0 10px;text-align: center;}
</style>



// WEBPACK FOOTER //
// Login.vue?aa6e1376